import { ProgramEnum } from '../../types/general';

export const programOptions = [
  { value: ProgramEnum.RESET, label: 'reSET' },
  { value: ProgramEnum.RESET_O, label: 'reSET-O' },
  { value: ProgramEnum.PEAR_002A, label: 'PEAR-002-A' },
];

export const emailRgx =
  // eslint-disable-next-line max-len, no-useless-escape
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
